import React, { FC } from 'react'
import { StyledIonButton } from './Button.styles'

type ButtonProps = Pick<HTMLIonButtonElement, 'type' | 'size' | 'disabled'> & {
  children?: React.ReactNode
}

export const Button: FC<ButtonProps> = ({ children, ...props }) => (
  <StyledIonButton {...props}>{children}</StyledIonButton>
)
